import React from 'react';
import { useAppMode } from '../../Providers/AppModeProvider';

const CollapsableAd = () => {
  const { trialStats, dateExpired } = useAppMode();
  if (!trialStats || dateExpired) {
    return null;
  }

  const remaining_tests = Math.max(
    (trialStats.total_attempts || 0) - (trialStats.attempted_tests || 0),
    0
  );

  return (
    <div
      className="px-4 py-2 rounded border border-primary-500 relative"
      style={{ backgroundColor: 'rgba(18, 175, 184, 0.2)' }}
    >
      <div className="font-bold">
        {trialStats.remaining_days === 0 ? (
          <>
            Your trial <span className="text-tertiary-600">ends today</span>. Use your{' '}
            <span className="text-tertiary-600">{remaining_tests}</span> remaining tests to gain insights.
          </>
        ) : (
          <>
            Your trial ends in{' '}
            <span className="text-tertiary-600">{trialStats.remaining_days}</span> days. Use your{' '}
            <span className="text-tertiary-600">{remaining_tests}</span> remaining tests to gain insights.
          </>
        )}
      </div>
    </div>
  );
  
  
};

export default CollapsableAd;
